import { render } from "./Crsreport.vue?vue&type=template&id=70274090&scoped=true"
import script from "./Crsreport.vue?vue&type=script&lang=js"
export * from "./Crsreport.vue?vue&type=script&lang=js"

import "./Crsreport.vue?vue&type=style&index=0&id=70274090&scoped=true&lang=css"

import exportComponent from "/harness/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70274090"]])

export default __exports__